import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackEnabledSelectAllParams = {
  trigger: 'meta+a' | 'action-bar';
  totalSelectionCount: number;
};

export const useTrackEnabledSelectAll = () => {
  const { track } = useAnalyticsUtilities();

  const trackEnabledSelectAll = useCallback(
    (params: TrackEnabledSelectAllParams) => {
      track('enabled_select_all', params);
    },
    [track],
  );

  return { trackEnabledSelectAll };
};
